module.exports = __webpack_public_path__ + "img/expired-link.f64e6da4.svg";